// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608141600/js/" + chunkId + "." + {"44":"ea4f1411","225":"2af0baf0","481":"6797ea23","486":"debf96cc","770":"955dba54"}[chunkId] + ".0.830193975284206.chunk.js";
};